import React from "react";

class Select extends React.Component {
  render() {
    const selectedOption = Array.isArray(this.props.options)
      ? this.props.options.find(opt => String(opt.value) === String(this.props.value))
      : null;
    const isSelectedDeleted = selectedOption && (
      selectedOption.is_deleted ||
      selectedOption.deleted_at != null ||
      selectedOption.deleted ||
      (selectedOption.style && selectedOption.style.color === 'gray')
    );

    const selectStyle = {
      ...(this.props.style || {}),
      ...(isSelectedDeleted ? { color: 'gray' } : {}),
    };

    return (
      <div className={`form-group ${this.props.size === "small" ? "m-0" : ""}`}>
        {this.props.label && (
          <label htmlFor={this.props.name} className={this.props?.labelClass}>
            {this.props.label} {this.props.icon}
          </label>
        )}
        <select
          {...this.props}
          style={selectStyle}
          className={`form-control${this.props.size === "small" ? "-sm" : ""} ${this.props.color ? this.props.color : ""
            } ${this.props.error ? this.props.error : ""}
          ${this.props.className ? this.props.className : ""}`}
        >
          <option
            value={this.props.defaultvalue !== undefined ? this.props.defaultvalue : ""}
            disabled={this.props.disabledFirst === undefined ? true : false}
          >
            {this.props.defaultname ? this.props.defaultname : "Seleccione"}
          </option>

          {(this.props.options || []).map((i, index) => {
            if (i.optgroup) {
              return (
                <optgroup label={i.label} key={index}>
                  {
                    (i.options || []).map((opt, optIndex) => {
                      const isDisabled = (opt.disabled !== undefined) ? !!opt.disabled : (opt.status !== undefined && opt.status === 0);
                      const isTruncated = this.props?.truncateLabel !== undefined && this.props?.truncateLabel > 0;
                      const truncatedLabel = isTruncated && String(opt.label).length >= 30
                        ? String(opt.label).substring(0, this.props.truncateLabel) + '...'
                        : opt.label;
                      const isDeleted = !!(
                        opt.is_deleted ||
                        opt.deleted_at != null ||
                        opt.deleted
                      );
                      const optionStyle = {
                        ...(isDeleted ? { color: 'gray' } : {}),
                        ...(opt.style || {}),
                      };

                      return (
                        <option
                          key={optIndex}
                          value={opt.value}
                          disabled={isDisabled}
                          style={Object.keys(optionStyle).length ? optionStyle : undefined}
                          className={opt.className || (isDeleted ? 'text-muted' : undefined)}
                        >
                          {(truncatedLabel || opt.label) ?? opt.name}
                        </option>
                      );
                    })
                  }
                </optgroup>
              )
            }
            else {
              const isDisabled = (i.disabled !== undefined) ? !!i.disabled : (i.status !== undefined && i.status === 0);
              const isTruncated = this.props?.truncateLabel !== undefined && this.props?.truncateLabel > 0;
              const truncatedLabel = isTruncated && String(i.label).length >= 30
                ? String(i.label).substring(0, this.props.truncateLabel) + '...'
                : i.label;
              const isDeleted = !!(
                i.is_deleted ||
                i.deleted_at != null ||
                i.deleted
              );
              const optionStyle = {
                ...(isDeleted ? { color: 'gray' } : {}),
                ...(i.style || {}),
              };

              return (
                <option
                  key={index}
                  value={i.value}
                  disabled={isDisabled}
                  style={Object.keys(optionStyle).length ? optionStyle : undefined}
                  className={i.className || (isDeleted ? 'text-muted' : undefined)}
                >
                  {(truncatedLabel || i.label) ?? i.name}
                </option>
              );
            }
          })}
        </select>
        {this.props.caret ? (
          this.props.caret
        ) : (
          <i
            className="fa fa-regular fa-chevron-down"
            style={{ position: 'absolute', bottom: 10, right: 10, fontSize: 20, color: 'gray' }}
          />
        )}
        {this.props.invalidfeedback}
      </div>
    );
  }
}

export default Select;
